import PickerShell from './PickerShell';

import type { DatePickerProps } from '../types';

const DatePicker = (props: DatePickerProps) => <PickerShell props={props} />;

DatePicker.displayName = 'DatePicker';

export default DatePicker;
